import React from "react";

import AvatarIcon from "assets/icons/AvatarIcon";

interface ProfileAvatarProps {
  pictureUrl: string;
  width?: number;
  height?: number;
  hoverBrighten?: boolean;
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  pictureUrl,
  width,
  height,
  hoverBrighten = false,
}) => {
  const sizeClasses =
    width && height ? `w-[${width}px] h-[${height}px]` : "w-[40px] h-[40px]";
  const imageHoverClass = hoverBrighten
    ? "transition-[filter] duration-200 ease-out hover:brightness-110"
    : "";
  return (
    <div className={`${sizeClasses} bg-[#dbdbdb] rounded-full`}>
      {pictureUrl ? (
        <img
          style={{ maxWidth: "100%", maxHeight: "100%" }}
          className={`rounded-full ${imageHoverClass}`}
          alt="profile"
          src={pictureUrl}
        />
      ) : (
        <AvatarIcon width={width || 40} height={height || 40} color={"white"} />
      )}
    </div>
  );
};

export default ProfileAvatar;
